export default __webpack_public_path__ + "static/media/logo2.67164b21.svg";